export function TrustIndicator() {
  return (
    <a
      href="https://gsap.com/showcase/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Featured on GSAP"
      className="bento-no-min flex flex-col justify-between items-center text-center h-full"
    >
      <span className="font-heading text-3xl tracking-tight bg-gradient-to-r from-[#0ae448] to-[#abff84] bg-clip-text text-transparent">
        GSAP
      </span>
      <span className="font-body text-sm text-muted-foreground font-light">
        Featured on
      </span>
    </a>
  );
}
